import { useEffect } from 'react';
import { isIOS } from '../../../native/utils/isIOS/isIOS';
import { useLocalStorage } from '../../../storage/hooks/useLocalStorage/useLocalStorage';

export interface NotificationPreferences {
  vibrationEnabled: boolean;
  audioEnabled: boolean;
}

const DEFAULT_PREFERENCES: NotificationPreferences = {
  audioEnabled: true,
  vibrationEnabled: true,
};

export const useNotificationPreferences = () => {
  const [preferences, setPreferences] = useLocalStorage('notification-preferences', DEFAULT_PREFERENCES);
  const isAppleDevice = isIOS();

  useEffect(() => {
    if (isAppleDevice && preferences.vibrationEnabled) {
      setPreferences((prev) => ({ ...prev, vibrationEnabled: false }));
    }
  }, [isAppleDevice, preferences.vibrationEnabled, setPreferences]);

  const setVibrationEnabled = (enabled: boolean) => {
    setPreferences((prev) => ({ ...prev, vibrationEnabled: enabled }));
  };

  const setAudioEnabled = (enabled: boolean) => {
    setPreferences((prev) => ({ ...prev, audioEnabled: enabled }));
  };

  return {
    audioEnabled: preferences.audioEnabled,
    isVibrationPossible: !isAppleDevice,
    setAudioEnabled,
    setVibrationEnabled,
    vibrationEnabled: preferences.vibrationEnabled,
  };
};
